// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

function initAnimations() {
  const textElements = document.querySelectorAll('.animation-text__text');

  const isMobile = window.innerWidth <= 768; // Adjust breakpoint as needed

  if (textElements.length > 0) {
    textElements.forEach(text => {
      gsap.set(text, {
        y: isMobile ? 30 : 100,
        fontSize: isMobile ? '96px' : '340px',
        lineHeight: isMobile ? '96px' : '425px',
        paddingTop: isMobile ? '0px' : '0px' 
      });

      gsap.to(text, {
        scrollTrigger: {
          trigger: text,
          start: "top 100%",
          end: "bottom 20%",
          scrub: true,
          toggleActions: "play none none reverse",
          markers: false,
          onEnter: () => console.log('Animation triggered')
        },
        y: 0,
        fontSize: isMobile ? '60px' : '96px',
        lineHeight: isMobile ? '60px' : '120px',
        paddingTop: isMobile ? '15px' : '20px',
        duration: 3.5,
        ease: "power3.out"
      });
    });
  }
}



// Initialize both animations
document.addEventListener('DOMContentLoaded', () => {
  initAnimations();
});

document.addEventListener('shopify:section:load', () => {
  initAnimations();
});

window.addEventListener('resize', () => {
  ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  initAnimations();
});
